import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Link from '../../../common/Link';
import Chevron from '../../../icons/Chevron';
export default function Element(props) {
    const { t } = useTranslation();
    return (_jsx("li", { children: _jsxs(Link, { to: props.link.url, className: "flex justify-between sm:py-4", children: [t(`layout.nav.${props.link.title}`), _jsx(Chevron, { className: "-rotate-90 sm:hidden" })] }) }));
}
